import {
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { StyledFooterRetailerAddress } from './FooterRetailer.styles';

interface FooterRetailerAddressProps {
  name?: string;
  address: string;
}

const FooterRetailerAddress = ({
  name,
  address,
}: FooterRetailerAddressProps) => {
  return (
    <StyledFooterRetailerAddress>
      <Text tag={TextTag.h3} appearance={TokenTextAppearance.bigcopy200}>
        {name}
      </Text>
      <div>{address}</div>
    </StyledFooterRetailerAddress>
  );
};

export default FooterRetailerAddress;
